import UserSetting from '@/micro-app/tb-usersetting';

export default [
  {
    title: '收费设置',
    path: '/chargeSetting',
    component(props) {
      return <UserSetting pathInUserSetting="/chargeSetting/" {...props} />;
    },
    hideInNav: true,
  },
  {
    title: '常用联系人设置',
    path: '/topcontract',
    component(props) {
      return <UserSetting pathInUserSetting="/topcontract/" {...props} />;
    },
    hideInNav: true,
  },
  {
    title: '收品模板设置池',
    path: '/templateSetting/page',
    component(props) {
      return <UserSetting pathInUserSetting="/templateSetting/page/" {...props} />;
    },
    hideInNav: true,
  },
  {
    title: '收品模板设置',
    path: '/templateSetting',
    component(props) {
      return <UserSetting pathInUserSetting="/templateSetting/" {...props} />;
    },
    hideInNav: true,
  },
  {
    title: '选品助手设置',
    path: '/selectSetting',
    component(props) {
      return <UserSetting pathInUserSetting="/selectSetting/" {...props} />;
    },
    hideInNav: true,
  },
  {
    title: '资质模版设置',
    path: '/aptitudeSetting',
    component(props) {
      return <UserSetting pathInUserSetting="/aptitudeSetting/" {...props} />;
    },
    hideInNav: true,
  },
  {
    title: '消息设置',
    path: '/msgsetting/secondkill',
    component(props) {
      return <UserSetting pathInUserSetting="/msgsetting/secondkill/" {...props} />;
    },
    hideInNav: true,
  },
  {
    title: ' 黑白名单设置',
    path: '/blacklistSetting',
    component(props) {
      return <UserSetting pathInUserSetting="/blacklistSetting/" {...props} />;
    },
    hideInNav: true,
  },
];
